import React from 'react';
import MarkerWidget from '../../components/survey_editor/heatmap/MarkerWidget';

export default function MarkerWidgetComponent(props) {
  return <MarkerWidget {...props} />;
}
